import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { environment } from '../../environments/environment';

/*
  Generated class for the MarketplaceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class MarketplaceProvider {
  URL = environment.marketplaceUrl;
  URLISM= environment.ismUrl;
  param=[]

  constructor(public http: HttpClient, private storage: Storage) {
    console.log('Hello MarketplaceProvider Provider');
  }

  getUsersList() {
    return this.getToken().then((val) => {
      if (val) {
        return this.http.get<any[]>(this.getUrlIsmUrl(`/users/${val.societyId}?`, val))
          .toPromise();
      }
    });
  }
  
  //	return HttpApiService.getRequest(SERVER_URL+'users/'+loginUser.societyId)
  getMarketPlace() {
    return this.getToken().then((val) => {
      if (val) {
        return this.http.get<any[]>(this.getUrl(`v1/society/${val.societyId}/markets/get?`, val))
          .toPromise();
      }
    });
  }


  getAllCategories(id) {
    return this.getToken().then((val) => {
      if (val) {
        return this.http.get<any[]>(this.getUrl(`v1/society/${val.societyId}/market/${id}/categories/get?`, val))
          .toPromise();
      }
    });
  }

  getMarketTrending(id) {
    return this.getToken().then((val) => {
      if (val) {
        return this.http.get<any[]>(this.getUrl(`v1/society/${val.societyId}/market/${id}/trendingitems/get?`, val))
          .toPromise();
      }
    });
  }

  getAllItem(marketid, id, param) {
    return this.getToken().then((val) => {
      if (val) {
        return this.http.get<any[]>(this.getUrl(`v1/society/${val.societyId}/market/${marketid}/category/${id}/items/active/get?`, val))
          .toPromise();
      }
    });
  }

  getSingleItem(marketid, categoryid, id) {
    return this.getToken().then((val) => {
      if (val) {
        return this.http.get<any[]>(this.getUrl(`v1/society/${val.societyId}/market/${marketid}/category/${categoryid}/item/${id}/get?`, val))
          .toPromise();
      }
    });
  }

  getItemReviews(id) {
    return this.getToken().then((val) => {
      if (val) {
        return this.http.get<any[]>(this.getUrl(`v1/society/${val.societyId}/item/${id}/reviews?`, val)+"pp[page_no]=1&pp[per_page]=20")
          .toPromise();
      }
    });
  }


  getResidentOffer(societyuuid,blockParam) {
    return this.getToken().then((val) => {
      if (val) {
        return this.http.get<any[]>(this.getUrl(`v1/society/${val.societyId}/user/${val.id}/items?`, val)+"&societyUUID="+societyuuid+"&block="+blockParam+"").toPromise();
      }
    });
  }


 // http://test-market-api.isocietymanager.com/v1/society/{societyId/user/{userId}/items?block=0/1
  
  search(marketid,query) {
    return this.getToken().then((val) => {
      if (val) {
        return this.http.get<Response>(this.getUrl(`v1/society/${val.societyId}/market/${marketid}/searchitems?`, val)+"&param[name]="+query+"&pp[page_no]=1&pp[per_page]=20")
          .toPromise();
      }
    });
  }


  click(societyuuid, marketid, categoryid, id) {
    return this.getToken().then((val) => {
      if (val) {
        return this.http.post<any>(this.getUrl(`v1/society/${val.societyId}/market/${marketid}/category/${categoryid}/item/${id}/click/post?`, val), {
          param: { clicked_by: val.id, actor: 'CUSTOMER' }, societyUUID: societyuuid
        })
          .toPromise();
      }
    });
  }

  review(feedback,rating, societyuuid, marketid, id) {
    return this.getToken().then((val) => {
      if (val) {
        return this.http.post<any>(this.getUrl(`v1/society/${val.societyId}/market/${marketid}/item/${id}/review/post?`, val), {
          param: { 
            created_by: val.id,
             actor: 'CUSTOMER',
              rating: rating,
               feedback: feedback 
              }, 
               societyUUID: societyuuid
        })
          .toPromise();
      }
    });
  }



  abuse(abuse,societyuuid,id) {
    return this.getToken().then((val) => {
      if (val) {
        return this.http.post<any>(this.getUrl(`v1/society/${val.societyId}/item/${id}/reportabuse?`, val), {
               actor: 'CUSTOMER',
               remarks: abuse,
               societyUUID: societyuuid
        })
          .toPromise();
      }
    });
  }

  contactSeller(societyuuid,id) {
    return this.getToken().then((val) => {
      if (val) {
        return this.http.post<any>(this.getUrl(`v1/society/${val.societyId}/item/${id}/contactseller?`, val), {
               actor: 'CUSTOMER',
               societyUUID: societyuuid
        })
          .toPromise();
      }
    });
  }

  //v1/society/{societyId}/item/itemUUID/contactseller?
  


  addOffer( societyuuid, marketid, categoryuuid,item,imagesUrl) {
    return this.getToken().then((val) => {
      if (val) {
        return this.http.post<any>(this.getUrl(`v1/society/${val.societyId}/market/${marketid}/category/${categoryuuid}/item/addresidentoffer?`, val), {
            param: {
                "actor": 'CUSTOMER',
                "created_by": val.id, 
                "name": item.name,
                "price": Number(item.price) ? Number(item.price) : '',
                "price_off": Number(item.price_off)? Number(item.price_off) : '',
                "percent_off": (((item.price_off) * 100) / item.price),
                "rating": '',
                "images": imagesUrl,
                "seller_name": item.seller_name ? item.seller_name : '',
                "seller_phone": item.seller_phone ? item.seller_phone : '',
                "seller_address": item.seller_address ? item.seller_address : '',
                "description": item.description,
                "till_date" : item.till_date
            },
            societyUUID: societyuuid
        })
          .toPromise();
      }
    });
  }



  getToken() {
    return this.storage.get("loginDetails");
  }

  getUrlIsmUrl(link: string, val: any): string {
    return `${this.URLISM}${link}api-token=${val.api_token}&user-id=${val.id}`;
  }

  getUrl(link: string, val: any): string {
    return `${this.URL}${link}api-token=${val.api_token}&user-id=${val.id}`;
  }




}



// WEBPACK FOOTER //
// ./src/providers/marketplace/marketplace.ts